import { Component, OnInit,HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-print-customer-request',
  templateUrl: './print-customer-request.component.html',
  styleUrls: ['./print-customer-request.component.scss']
})
export class PrintCustomerRequestComponent implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  dataOfPrint:any;
  isLoading=true;
  showPage=false;
  request_at='สำนักงานใหญ่ เทศบาลพัทยา';
  request_date='01';
  request_month='มิถุนายน';
  request_year='2563';
  customer_fullname='นายอำนาจ อ่วมทิม';
  customer_age='34';
  customer_race='ไทย';
  customer_nationality='ไทย';
  customer_house_number='108/151';
  customer_moo='2';
  customer_road='พระราม 2';
  customer_tambon='พันท้ายนรสิงห์';
  customer_amphur='เมืองสมุทรสาคร';
  customer_province='สมุทรสาคร';
  customer_phone_number='0818442580';
  request_to='ฝ่ายสิ่งแวดล้อม';
  request_desc='ต้องการขอเพิ่มการจัดเก็บค่าธรรมเนียมเพิ่มเติม';
  request_desc2='-';
  request_desc3='-';
  request_desc4='-';
  request_desc5='-';
  opinion='สามารถเพิ่มเติมได้ แต่ต้องยื่นเรื่องไปยังทางสิ่งแวดล้อมเพื่อทำการตรวจสอบข้อมูล';
  opinion2='';
  opinion3='';
  opinion4='';
  command='ทดสอบ';
  command2='';
  request_id='-';
  base64_img_muni = null;
  img_src = null;
  muni_thname = null;
  muni_amphurth = null;
  muni_tambonth = null;
  muni_thprovince = null;
  muni_postcode = null;
  muni_contact_phone = null;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.isLoading=true;
    //debugger;
    
    const get_Storage_invoice_multi = sessionStorage.getItem('municipality')
    this.base64_img_muni = `data:image/png;base64,${JSON.parse(get_Storage_invoice_multi).icon_img}`
    this.img_src = this.sanitizer.bypassSecurityTrustUrl(this.base64_img_muni);
    const thname_muni = JSON.parse(get_Storage_invoice_multi).th_name;
    this.muni_thname = this.sanitizer.bypassSecurityTrustHtml(thname_muni);
    const thamphurth_muni = JSON.parse(get_Storage_invoice_multi).th_amphur;
    this.muni_amphurth = this.sanitizer.bypassSecurityTrustHtml(thamphurth_muni);
    const tambonth_muni = JSON.parse(get_Storage_invoice_multi).th_tambon;
    this.muni_tambonth = this.sanitizer.bypassSecurityTrustHtml(tambonth_muni);
    const provinceth_muni = JSON.parse(get_Storage_invoice_multi).th_province;
    this.muni_thprovince = this.sanitizer.bypassSecurityTrustHtml(provinceth_muni);
    const postcode_muni = JSON.parse(get_Storage_invoice_multi).postcode;
    this.muni_postcode = this.sanitizer.bypassSecurityTrustHtml(postcode_muni);
    const phone_muni = JSON.parse(get_Storage_invoice_multi).contact_phone;
    this.muni_contact_phone = this.sanitizer.bypassSecurityTrustHtml(phone_muni);
    if (JSON.stringify(localStorage.getItem('dataOfPrint')) == "\"undefined\"" || JSON.stringify(localStorage.getItem('dataOfPrint')) == "null")
    {
      this.request_at='-';
      this.request_date='-';
      this.request_month='-'
      this.request_year='-';
      this.customer_fullname='-'
      this.customer_age='-';
      this.customer_race='-';
      this.customer_nationality='-';
      this.customer_house_number='-';
      this.customer_moo='-';
      this.customer_road='-';
      this.customer_tambon='-'
      this.customer_amphur='-'
      this.customer_province='-'
      this.customer_phone_number='-'
      this.request_to='-';
      this.request_desc='-'
      this.request_desc2='-'
      this.request_desc3='-'
      this.request_desc4='-'
      this.request_desc5='-'
      this.opinion='-',
      this.opinion2='-';
      this.opinion3='-';
      this.opinion4='-'
      this.command='-',
      this.command2='-',
      this.request_id='-'
    }
    else 
    {
      //debugger;
      this.dataOfPrint = JSON.parse(localStorage.getItem('dataOfPrint'));
      this.request_at=this.dataOfPrint.data.request_at;
      this.request_date=this.dataOfPrint.data.request_date;
      this.request_month=this.dataOfPrint.data.request_month;
      this.request_year=this.dataOfPrint.data.request_year;
      this.customer_fullname=this.dataOfPrint.data.request_customer;
      this.customer_age=this.dataOfPrint.data.request_age;
      this.customer_race=this.dataOfPrint.data.request_race;
      this.customer_nationality=this.dataOfPrint.data.request_nationality;
      this.customer_house_number=this.dataOfPrint.data.request_house_number;
      this.customer_moo=this.dataOfPrint.data.request_house_moo;
      this.customer_road=this.dataOfPrint.data.request_house_road;
      this.customer_tambon=this.dataOfPrint.data.request_house_tambon;
      this.customer_amphur=this.dataOfPrint.data.request_house_amphur;
      this.customer_province=this.dataOfPrint.data.request_house_province;
      this.customer_phone_number=this.dataOfPrint.data.request_house_mobile;
      this.request_to='...........................................................................................................................................................................................................................';
      this.request_desc=this.dataOfPrint.data.request_desc1;
      this.request_desc2=this.dataOfPrint.data.request_desc2;
      this.request_desc3='-'
      this.request_desc4='-'
      this.request_desc5='-'
      this.opinion='.................................................................................................................................................................................................................................................................................';
      this.opinion2='.................................................................................................................................................................................................................................................................................';
      this.opinion3='.................................................................................................................................................................................................................................................................................';
      this.opinion4='.................................................................................................................................................................................................................................................................................';
      this.command='.................................................................................................................................................................................................................................................................................';
      this.command2='.................................................................................................................................................................................................................................................................................';
      this.request_id = this.dataOfPrint.data.request_general_id
    }

    this.isLoading=false;
    setTimeout(() => {
      window.print();
    }, 1000);
    
  }

}
